import React, { useState } from "react";
import dataService from "../../../../helpers/dataService";

const useRDVPies = (url, year, otherPostParams) => {
  const [isLoading, setIsLoading] = useState(false);
  const [chartState, setChartState] = useState(false);
  const [total1, setTotal1] = useState(0);
  const [total2, setTotal2] = useState(0);

  const months = [
    "Jan",
    "Fev",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Aou",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const lineOptions = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },

    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: months,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
  };

  const getDatas = () => {
    setIsLoading(true);

    dataService.post(
      `${url}`,
      { year, ...otherPostParams },
      (datas) => {
        var allTotal1 = datas.rdvEG.map((o) => o.months.reduce((a, b) => a + b));
        setTotal1(allTotal1.reduce((a, b) => a + b));

        var allTotal2 = datas.rdvRdsp.map((o) => o.months.reduce((a, b) => a + b));
        setTotal2(allTotal2.reduce((a, b) => a + b));

        setChartState({
          rdvRdspReported: datas.rdvRdspReported || 0,
          rdvEGReported: datas.rdvEGReported || 0,
          line1: {
            series: datas.rdvEG.map((o) => ({
              name: o.name,
              data: o.months,
            })),
            options: lineOptions,
          },
          pie1: {
            series: datas.rdvEG.map((o) => o.months.reduce((a, b) => a + b)),
            options: {
              labels: datas.rdvEG.map((o) => o.name),
              legend: { position: "bottom" },
              chart: {
                toolbar: {
                  show: true,
                },
              },
            },
          },
          line2: {
            series: datas.rdvRdsp.map((o) => ({
              name: o.name,
              data: o.months,
            })),
            options: lineOptions,
          },
          pie2: {
            series: datas.rdvRdsp.map((o) => o.months.reduce((a, b) => a + b)),
            options: {
              labels: datas.rdvRdsp.map((o) => o.name),
              legend: { position: "bottom" },
              chart: {
                toolbar: {
                  show: true,
                },
              },
            },
          },
        });
      },
      (e) => {},
      () => setIsLoading(false)
    );
  };

  var hasDatas = chartState;

  return {
    isLoading,
    getDatas,
    chartState,
    hasDatas,
    total1,
    total2,
  };
};

export default useRDVPies;
